<div class="mb-4 d-flex-between">
  <div class="d-grid">
    <h3 class="mb-0">{{ "instituation.list-page-title" | translate }}</h3>
    <p>{{ "instituation.list-page-description" | translate }}</p>
  </div>
  <div class="d-flex align-items-center">
    <a class="btn btn-warning ms-2" (click)="filterCollaps = !filterCollaps">
      {{ "general.filter" | translate }}
    </a>
    <button
      type="button"
      class="btn btn-primary ms-2"
      (click)="initilize()"
    >
      {{ "instituation.add-button" | translate }}
    </button>
  </div>
</div>

<div class="row">
  <div class="col-xl-12 active-p">
    <div class="filter cm-content-box box-primary" *ngIf="filterCollaps">
      <div class="content-title">
        <div class="cpa">
          <i class="fa-sharp fa-solid fa-filter me-2"></i
          >{{ "general.filter" | translate }}
        </div>
        <div class="tools">
          <a (click)="filterCollaps = false" class="btn btn-default btn-icon-md"
            ><i class="fa fa-close"></i
          ></a>
        </div>
      </div>

      <div class="cm-content-body form excerpt">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-3 col-sm-6">
              <input
                type="search"
                class="form-control mb-xl-0 mb-3"
                [placeholder]="'instituation.search-placeholder' | translate"
                aria-controls="user-tbl"
                [(ngModel)]="filter.search"
              />
            </div>

            <div class="col-xl-3 col-sm-6">
              <p-dropdown
                [options]="activityOptions"
                [showClear]="true"
                [placeholder]="'instituation.status-placeholder' | translate"
                [(ngModel)]="filter.isActive"
              >
              </p-dropdown>
            </div>
            <div class="col-12 d-flex justify-content-end mt-3">
              <button
                class="btn btn-danger light"
                (click)="clearFilter()"
                type="button"
              >
                {{ "general.clear-filter" | translate }}
              </button>
              <button
                class="btn btn-info ms-2"
                type="button"
                (click)="getList({})"
              >
                {{ "general.filtering" | translate }}
                <i class="fa fa-search ms-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-12 active-p">
    <div class="card">
      <div class="card-body p-0">
        <div class="table-responsive active-projects style-1">
          <div class="tbl-caption">
            <h4 class="heading mb-0">
              {{ "instituation.list-table-name" | translate }}
            </h4>
          </div>
          <p-table
            [rowHover]="true"
            responsiveLayout="stack"
            [rows]="rows"
            [first]="first"
            [totalRecords]="totalRecords"
            [lazy]="true"
            (onLazyLoad)="getList($event)"
            paginatorDropdownAppendTo="body"
            [value]="instituationList"
            [paginator]="true"
            [rowsPerPageOptions]="[10, 20, 30]"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="id" scope="col">
                  <span class="p-column-title"
                    >{{ "common.id" | translate }} <p-sortIcon field="id"
                  /></span>
                </th>
                <th pSortableColumn="title" scope="col">
                  <span class="p-column-title">
                    {{ "instituation.title" | translate }}
                    <p-sortIcon field="title"
                  /></span>
                </th>
                <th pSortableColumn="signboard" scope="col">
                  <span class="p-column-title">
                    {{ "instituation.signboard" | translate }}
                    <p-sortIcon field="signboard"
                  /></span>
                </th>
                <th scope="col">
                  <span class="p-column-title">
                    {{ "instituation.active-passive" | translate }}
                  </span>
                </th>

                <th scope="col"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-list>
              <tr>
                <td>{{ list?.id }}</td>
                <td>{{ list?.title }}</td>
                <td>{{ list?.signboard }}</td>
                <td>
                  <span
                    [ngClass]="
                      list?.isActive ? 'badge-success' : 'badge-danger'
                    "
                    class="badge light border-0"
                    >{{
                      list.isActive
                        ? ("general.status.active" | translate)
                        : ("general.status.passive" | translate)
                    }}</span
                  >
                </td>

                <td>
                  <i class="pi pi-pencil edit-history-action-icon" (click)="initilize(list)"></i>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="paginatorleft">
              {{ totalRecords }} {{ "common.table.totalFound" | translate }}
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="99">{{ "common.noData" | translate }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-create-instituation
  #instituationCreate
  (onSave)="onSave($event)"
  (onUpdate)="onUpdate($event)"
></app-create-instituation>

<app-sweet-alert></app-sweet-alert>
<app-toastr></app-toastr>

<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
